import { TabType } from './Types/index';

import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

type DefaultProps = { name: string; disabled?: boolean };

export type DefaultTabsProps = {
  tabs: DefaultProps[];
};

interface Props extends DefaultTabsProps, PropsWithClassName {
  activeTab: number;
  disabled?: boolean;
  classNameTabs?: PropsWithClassName['className'];
  variant?: 'underline' | 'primary';
  onClick: (tab: TabType) => void;
}

const tabBtnCN =
  'text-xs lg:text-sm flex-1 font-semibold flex items-center justify-center text-gdt-gray-2 border-[1.5px] border-gdt-gray-5 bg-white py-0';
const tabBtnActiveCN = 'border-gdt-blue bg-gdt-blue text-white';
const tabWithBorderBottom = `${tabBtnCN} h-[full] border-t-0 border-t-0 border-l-0 border-r-0 border-b-0 mx-auto flex-none`;
const tabWithBorderBottomActive = `${tabWithBorderBottom} relative after:absolute after:bg-gdt-blue text-gdt-blue font-bold after:w-full after:h-[3px] after:rounded-lg after:top-[98%]`;
export const Tabs = ({
  disabled,
  activeTab,
  onClick,
  tabs,
  className,
  classNameTabs,
  variant,
}: Props) => {
  const underlineVariant = variant === 'underline';

  return (
    <div
      className={cn(
        `flex w-full lg:max-w-[333px] mt-2 lg:mt-0 lg:h-[49px] h-[42px] ${className}`,
        {
          'border-b-gdt-gray-5 border-opacity-30 border-b-[1px] m-auto h-9 mt-3':
            underlineVariant,
        }
      )}
    >
      {tabs?.map((tab, index) => {
        return (
          <button
            key={index}
            className={cn(
              `${tabBtnCN} ${classNameTabs}`,
              {
                'rounded-tl-lg rounded-bl-lg !border-r-0': index === 0,
                'rounded-tr-lg rounded-br-lg !border-l-0':
                  index === tabs.length - 1,
                '!bg-transparent': underlineVariant,
              },
              {
                [tabBtnActiveCN]: activeTab === index,
                [tabWithBorderBottom]: underlineVariant,
                [tabWithBorderBottomActive]:
                  activeTab === index && underlineVariant,
              }
            )}
            disabled={tab.disabled || disabled}
            type="button"
            onClick={() => onClick(index)}
          >
            {tab.name}
          </button>
        );
      })}
    </div>
  );
};
